import { render, staticRenderFns } from "./centCommission.vue?vue&type=template&id=047b44d6&"
import script from "./centCommission.vue?vue&type=script&lang=js&"
export * from "./centCommission.vue?vue&type=script&lang=js&"
import style0 from "./centCommission.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports